import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { FileText, X } from "lucide-react";

const POLICY_VERSION_KEY = "privacy-policy-version-seen";
const CURRENT_POLICY_VERSION = "2026-06";

export function PrivacyPolicyBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const seenVersion = localStorage.getItem(POLICY_VERSION_KEY);
    if (seenVersion !== CURRENT_POLICY_VERSION) {
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  function handleAcknowledge() {
    localStorage.setItem(POLICY_VERSION_KEY, CURRENT_POLICY_VERSION);
    setVisible(false);
  }

  function handleDismiss() {
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 border-t border-primary/20 bg-primary/5 p-4 shadow-lg backdrop-blur-sm animate-in slide-in-from-bottom">
      <div className="mx-auto flex max-w-7xl flex-col items-start gap-3 md:flex-row md:items-center md:justify-between">
        <div className="flex items-start gap-3 md:items-center">
          <FileText className="mt-0.5 h-5 w-5 shrink-0 text-primary md:mt-0" />
          <div className="text-sm">
            <span className="font-medium">Nossa Política de Privacidade foi atualizada. </span>
            <span className="text-muted-foreground">
              Revisamos e atualizamos nossos termos para garantir total conformidade com a LGPD.
            </span>
          </div>
        </div>

        <div className="flex shrink-0 items-center gap-2">
          <Button variant="outline" size="sm" asChild>
            <a
              href="/privacidade/politica-de-privacidade.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              Revisar alterações
            </a>
          </Button>
          <Button size="sm" onClick={handleAcknowledge}>
            Entendi
          </Button>
          <button
            type="button"
            onClick={handleDismiss}
            className="ml-1 rounded-sm p-1 text-muted-foreground opacity-70 hover:opacity-100"
          >
            <X className="h-4 w-4" />
            <span className="sr-only">Fechar</span>
          </button>
        </div>
      </div>
    </div>
  );
}
